import { Button, Grid, TextField } from "@mui/material";
import GlobalDialogContent from "../GlobalDialogContent";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../../redux/reducer/snackbarSlice";
import { closeDialog } from "../../../redux/reducer/dialogSlice";
import { useSearchParams } from "react-router-dom";
import { RegisterEventService } from "../../../utils/services/project/project";
import { setModuleRefresh } from "../../../redux/reducer/registration/RefreshSlice";
import { RootState } from "../../../redux/store";
import PageLang from "../../../config/page.languge";

const RegisterEvent = () => {
    const dispatch = useDispatch();
    const lang=useSelector((state:RootState)=>state.lang.language)
      const [searchParams] = useSearchParams();
    const uuid = searchParams.get("uuid");
    const formik = useFormik({
        initialValues: {
            fname: "",
            lname: "",
            contact: "",
            email: "",
            address: "",
        },
        validationSchema: Yup.object({
            fname: Yup.string().required(PageLang?.diaLogues.Event.Registration.Errors.firstNameRequired[lang]),
            lname: Yup.string().required(PageLang?.diaLogues.Event.Registration.Errors.lastNameRequired[lang]),
            contact: Yup.string().matches(/^\d{10}$/, PageLang?.diaLogues.Event.Registration.Errors.contactValidation[lang]).required(PageLang?.diaLogues.Event.Registration.Errors.mobileNumberRequired[lang]),
            email: Yup.string().email(PageLang?.diaLogues.Event.Registration.Errors.emailValidation[lang]).required( PageLang?.diaLogues.Event.Registration.Errors.emailRequired[lang]),
            address: Yup.string().min(5, PageLang?.diaLogues.Event.Registration.Errors.addressValidation[lang]).required(PageLang?.diaLogues.Event.Registration.Errors.addressRequired[lang]),
        }),
        onSubmit: async (values) => {
            const payload = {
                uuid: uuid,
                firstname: values?.fname,
                lastname: values?.lname,
                email: values?.email,
                mobile_no: values?.contact,
                address: values?.address
            }
            const { code, message } = await RegisterEventService(payload);
            if (code === 200) {
                dispatch(showSnackbar({ type: "success", message: message || 'Succesfully.' }));
                dispatch(closeDialog());
                dispatch(setModuleRefresh({ moduleName: 'register_event', refresh: true }));                
            } else {
                dispatch(showSnackbar({ type: "error", message: message || ' error.' }));

            }
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <GlobalDialogContent
                dialogBody={
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label={PageLang?.diaLogues.Event.Registration.fname[lang]}
                                name="fname"
                                value={formik.values.fname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.fname && Boolean(formik.errors.fname)}
                                helperText={formik.touched.fname && formik.errors.fname}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label={PageLang?.diaLogues.Event.Registration.lastName[lang]}
                                name="lname"
                                value={formik.values.lname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.lname && Boolean(formik.errors.lname)}
                                helperText={formik.touched.lname && formik.errors.lname}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label={PageLang?.diaLogues.Event.Registration.mobileNumber[lang]}
                                name="contact"
                                type="text"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                      formik.handleChange(e);
                                    }
                                  }}
                                inputProps={{ maxLength: 10}}
                                value={formik.values.contact}
                                onBlur={formik.handleBlur}
                                error={formik.touched.contact && Boolean(formik.errors.contact)}
                                helperText={formik.touched.contact && formik.errors.contact}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label={PageLang?.diaLogues.Event.Registration.email[lang]}
                                name="email"
                                type="email"
                                value={formik.values.email}
                                onChange={(e) => {
                                    formik.setFieldValue('email', e.target.value.toLowerCase());
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label={PageLang?.diaLogues.Event.Registration.address[lang]}
                                name="address"
                                multiline
                                rows={3}
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.address && Boolean(formik.errors.address)}
                                helperText={formik.touched.address && formik.errors.address}
                            />
                        </Grid>
                    </Grid>
                }
                dialogFooter={
                    <>
                        <>
                            <Button type="submit" variant="contained" color="success">
                                {PageLang?.diaLogues.Event.Registration.submit[lang]}
                            </Button>
                        </>
                    </>
                }
            />
        </form>
    );
};

export default RegisterEvent;
